export const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

export const PICKERS = {
    day: 'day',
    month: 'month',
    year: 'year'
};

export const DATE_PART = {
    day: 'DD',
    month: 'MM',
    year: 'YYYY'
};

export const RANGE = Object.freeze({
    PAST: 'PAST',
    FUTURE: 'FUTURE'
});
